import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import { Card, CardFooter } from '@components/card/card';
import { CardBody, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import { TreeSelect } from 'antd';
import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
// import confirmAction from '@components/Shared/Alert/confirmAction';
import { updateArReceipts, getArReceiptsById, cancelArReceipts } from '@store/Finance/AR/ArReceipts/ArReceiptsSlice';
import useGetBankAccountsList from '@hooks/Finance/BankAccounts/useGetBankAccountsList';
import useGetReceiptsTypeList from '@hooks/Finance/ArReceipts/useGetReceiptsTypeList';
// import { AddApPaymentsSchema } from '../../../../ValidationForm/validationSchema';
// import useGetBranchOrgWithPermission from '@hooks/NTX/Organization/useGetBranchOrgWithPermission';
import { useEffect, useState } from 'react';
import ArScheduleList from '../ArScheduleList';
import useGetCustomersList from '@hooks/NTX/Peoples/useGetCustomersList';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import { receiptTypeEnum } from '../receiptTypeEnum';
import NeatixModal from '@components/Modal/NeatixModal';
import JournalsByReference from '@pages/Finance/Journals/JournalsByReference/JournalsByReference';
import ReceiptDetailsCard from '../Add/ReceiptDetailsCard';
import ButtonPrint from '@components/Print/ButtonPrint';

const Update = () => {
  const [show, setShow] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { receiptId } = useParams();

  const { Currency, loading: loading4 } = useLookupCurrency();
  const { OperatingUnitOptions, loading: loading3, error: error7 } = useGetOperatingUnitWithPermission();
  const { treeCustomerData, error: error2, loading: loading2 } = useGetCustomersList();
  const { PaymentMethodList } = useGetPaymentMethod();
  const { groupedOptions, OptionsBankAccounts, loading: loading5, error: error5 } = useGetBankAccountsList();
  const { ReceiptsTypeList } = useGetReceiptsTypeList();

  useEffect(() => {
    if (receiptId) {
      dispatch(getArReceiptsById(receiptId));
    }
  }, [receiptId, dispatch]);

  const { ArReceiptsById: data, loadingById, errorById } = useAppSelector(a => a.ArReceipts);

  // تحديد إذا كان السند مرحلاً أو ملغياً
  const isPosted = data?.postedFlag === true;
  const isCancelled = data?.status === 'cancelled';

  //#region Formik
  const formik = useFormik({
    initialValues: {
      // preReceiptTotal: data.receiptType === receiptTypeEnum.PreReceipt ? data.amount || 0 : 0,
      receiptType: data.paymentType ?? '',
      depositDate: data.depositDate?.split('T')[0] ?? '',
      bankAccountId: data.bankAccountId ?? '',
      depositMethodId: data.depositMethodId ?? '',
      amount: data.amount ?? '',
      currencyCode: data.currencyCode ?? '',
      currencyConversionRate: data.currencyConversionRate ?? '',
      peopleId: data.peopleId ?? '',
      organizationId: data.organizationId ?? '',
      dibetMemoTransactionId: data.dibetMemoTransactionId ?? '',
      preReceiptId: data.preReceiptId ?? '',
      scheduleList:
        data?.transactionReceiptList?.map(item => ({
          id: item.id,
          arReceiptScheduleId: item.arReceiptScheduleId,
          transactionNum: item.transectionNum,
          transactionDate: item.transectionDate?.split('T')[0],
          dueDate: item.dueDate?.split('T')[0],
          transactionAmount: item.transectionAmount,
          schadualAmount: item.schadualAmount,
          amount: item.amount,
          actualRemainingAmount: item.schadualAmount
        })) ?? []
    },

    enableReinitialize: true,
    // validationSchema: AddArReceiptsSchema(t),

    onSubmit: async values => {
      // منع التعديل إذا كان مرحلاً
      // if (isPosted) {
      //   CustomAlert({ action: 'info', msg: t('لا يمكن تعديل السندات بعد الترحيل') });
      //   formik.setSubmitting(false);
      //   return;
      // }
      // const isConfirmation = await confirmAction('هل أنت متأكد من أنك تريد تعديل هذا القبض؟');
      // if (!isConfirmation) {
      //   formik.setSubmitting(false);
      //   return;
      // }
      // const totalAmount = values.scheduleList?.reduce((sum: any, line: any) => sum + line.amount, 0);
      // dispatch(
      //   updateArReceipts({
      //     id: data.id,
      //     bankAccountId: values.bankAccountId,
      //     depositMethodId: values.depositMethodId,
      //     depositDate: values.depositDate,
      //     amount: values.receiptType === receiptTypeEnum.PreReceipt ? values.amount : totalAmount,
      //     transactionReceiptList:
      //       values.receiptType === receiptTypeEnum.PreReceipt
      //         ? []
      //         : values.scheduleList.map(item => ({
      //             id: item.id,
      //             arReceiptScheduleId: item.arReceiptScheduleId,
      //             amount: item.amount
      //           }))
      //   })
      // )
      //   .unwrap()
      //   .then((res: any) => {
      //     if (res?.succeeded === true) {
      //       CustomAlert({ action: 'Edit' });
      //       navigate('/Finance/Ar/ArReceipts', { replace: true });
      //     } else {
      //       CustomAlert({ action: 'Error', msg: res?.message });
      //     }
      //   })
      //   .catch((error: any) => {
      //     CustomAlert({ action: 'Error' });
      //   })
      //   .finally(() => {
      //     formik.setSubmitting(false);
      //   });
    }
  });
  const { values, handleChange: formikhandleChange, errors, touched, setFieldValue, setFieldTouched } = formik;
  //#endregion

  // دالة إلغاء السند
  const handleCancelReceipt = async () => {
    if (!receiptId) return;

    dispatch(cancelArReceipts({ receiptId: receiptId }))
      .unwrap()
      .then((res: any) => {
        if (res?.succeeded === true) {
          CustomAlert({ action: 'Add', msg: t('تم إلغاء السند بنجاح') });
          setShowCancelModal(false);
          navigate('/AR/ArReceipts', { replace: true });
        } else {
          CustomAlert({ action: 'Error', msg: res?.message || t('فشل في إلغاء السند') });
        }
      })
      .catch((error: any) => {
        CustomAlert({ action: 'Error', msg: error || t('حدث خطأ أثناء إلغاء السند') });
      });
  };

  // console.log(data);

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'سندات القبض',
              link: '/AR/ArReceipts'
            },
            {
              name: 'تفاصيــل سند القبض',
              link: null
            }
          ]}
          PageName='تفاصيــل سند القبض'
        />
        <div className='ms-auto'>
          <div className='col-5 col-md-6 text-end'>
            <ButtonPrint
              PrintTemplateTypeId='DE47917F-5794-4192-86FD-3667ED4E0644' // قوالب سندات الإستلام
              ReferenceId={data?.id || ''}
            />
          </div>
        </div>
      </div>

      <Card>
        <Loading
          loading={loading5 || loading2 || loading3 || loading4 || loadingById}
          error={error2 || error5 || error7 || errorById}
        >
          {isPosted && (
            <div className='alert alert-info d-flex align-items-center justify-content-between m-2'>
              <div className='d-flex align-items-center'>
                <i className='fas fa-info-circle fa-2x me-3'></i>
                <div>
                  <h5 className='mb-1'>{t('تم ترحيـل السند')}</h5>
                  <p className='mb-0'>{t('لا يمكن تعديل السندات بعد الترحيل في النظام')}</p>
                </div>
              </div>

              <button type='button' className='btn btn-sm btn-info' onClick={() => setShow(true)}>
                <i className='fa fa-info-circle fa-fw me-1'></i>
                {t('عرض القيد')}
              </button>
            </div>
          )}

          {isCancelled && (
            <div className='alert alert-warning d-flex align-items-center justify-content-between m-2'>
              <div className='d-flex align-items-center'>
                <i className='fas fa-ban fa-2x me-3'></i>
                <div>
                  <h5 className='mb-1'>{t('تم إلغاء السند')}</h5>
                  <p className='mb-0'>{t('هذا السند تم إلغاؤه ولا يمكن تعديله')}</p>
                </div>
              </div>
            </div>
          )}

          <Form onSubmit={formik.handleSubmit}>
            <CardBody>
              <div className='row'>
                {/* نوع القبض */}
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('نوع السند')}</label>
                    <Form.Select
                      disabled
                      className='form-select'
                      name='receiptType'
                      onChange={formikhandleChange}
                      value={values.receiptType || ''}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {ReceiptsTypeList?.map((item, idx) => (
                        <option key={idx} value={item.id}>
                          {i18n.language === 'en' ? item.name : item.name2}
                        </option>
                      ))}
                    </Form.Select>
                    <div className='text-danger small'>{touched.receiptType && formik.errors.receiptType}</div>
                  </div>
                </div>

                {/* {t('العميل')} */}
                <div className='col-lg-3 '>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('العميل')}</label>
                    <TreeSelect
                      disabled
                      showSearch
                      className='w-100'
                      treeLine
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      allowClear
                      treeDefaultExpandAll={false}
                      value={values.peopleId}
                      onChange={option => {
                        formik.setFieldValue('peopleId', option === null ? null : option);
                      }}
                      treeData={treeCustomerData}
                      treeNodeFilterProp='title'
                    />
                    <div className='text-danger small'>{touched.peopleId && errors.peopleId}</div>
                  </div>
                </div>

                {/* ('الفرع') */}
                <div className='col-lg-3  '>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('الفرع')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading3}
                      isSearchable={true}
                      isClearable
                      options={OperatingUnitOptions}
                      value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
                      onChange={(option: any) => setFieldValue('organizationId', option === null ? null : option.value)}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger small'>{touched.organizationId && errors.organizationId}</div>
                  </div>
                </div>

                {/* التاريخ */}
                <div className='col-lg-3  '>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('التاريخ')}</label>
                    <Form.Control
                      disabled={isPosted}
                      className='form-control text-center'
                      type='date'
                      name='depositDate'
                      onChange={formikhandleChange}
                      value={values.depositDate || ''}
                    />
                    <div className='text-danger small'>{touched.depositDate && errors.depositDate}</div>
                  </div>
                </div>

                {![receiptTypeEnum.ApplyDebitMemo, receiptTypeEnum.ApplyPreReceipt].includes(values.receiptType) && (
                  <>
                    {/* طريقة الدفع */}
                    <div className='col-lg-3 '>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('PaymentMethod')}</label>
                        <Form.Select
                          disabled={isPosted}
                          className='form-select'
                          name='depositMethodId'
                          onChange={formik.handleChange}
                          value={formik.values.depositMethodId || ''}
                        >
                          <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                          {PaymentMethodList?.map((item: any, idx: number) => (
                            <option key={++idx} value={item.id}>
                              {i18n.language === 'en' ? item.name : item.name2}
                            </option>
                          ))}
                        </Form.Select>
                        <div className='text-danger small'>{touched.depositMethodId && errors.depositMethodId}</div>
                      </div>
                    </div>

                    {/* bankAccountId */}
                    <div className='col-lg-3 '>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('البنك / الصندوق')}</label>
                        <Select
                          isDisabled={isPosted || loading5}
                          classNamePrefix='react-select'
                          isLoading={loading5}
                          isSearchable={true}
                          isClearable
                          options={groupedOptions}
                          // value={OptionsBankAccounts?.find((item: any) =>
                          //   item?.options?.some((option: any) => option.value === formik.values.bankAccountId)
                          // )}
                          value={OptionsBankAccounts?.find((f: any) => f.value === formik.values.bankAccountId)}
                          onChange={(option: any) =>
                            setFieldValue('bankAccountId', option === null ? null : option?.value)
                          }
                          placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                        />
                        <div className='text-danger small'>{touched.bankAccountId && errors.bankAccountId}</div>
                      </div>
                    </div>

                    {/* ('Currency') */}
                    <div className='col-lg-3'>
                      <div className='form-group mb-3'>
                        <label className='form-label'> {t('Currency')} </label>
                        <Form.Select
                          disabled
                          className='form-select'
                          name='currencyCode'
                          onChange={formikhandleChange}
                          value={values.currencyCode || ''}
                        >
                          <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                          {Currency &&
                            Currency?.map((item: any, idx: number) => (
                              <option key={++idx} value={item.currencyCode}>
                                {item.description}
                              </option>
                            ))}
                        </Form.Select>
                        <div className='text-danger small'>{touched.currencyCode && errors.currencyCode}</div>
                      </div>
                    </div>

                    {/* ('معدل العملة') */}
                    <div className='col-lg-3 '>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('معدل العملة')}</label>
                        <Form.Control
                          disabled
                          readOnly
                          className='form-control text-center'
                          type='text'
                          autoComplete='off'
                          name='currencyConversionRate'
                          value={values.currencyConversionRate}
                        />
                      </div>
                    </div>
                  </>
                )}

                {values.receiptType === receiptTypeEnum.PreReceipt && (
                  <div className='col-lg-3'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('مبلغ المقبوضات المقدمة')}</label>
                      <Form.Control
                        disabled={isPosted}
                        className='form-control text-center fs-5 fw-bold text-theme'
                        type='text'
                        autoComplete='off'
                        name='amount'
                        onChange={formikhandleChange}
                        value={values.amount || ''}
                        onInput={e => {
                          const input = e.target as HTMLInputElement;
                          input.value = input.value.replace(/[^0-9]/g, '');
                        }}
                      />
                      <div className='text-danger small'>{errors.amount}</div>
                    </div>
                  </div>
                )}
              </div>
            </CardBody>

            <CardFooter className='mt-0 p-0'>
              <ReceiptDetailsCard
                receiptType={values.receiptType}
                Id={
                  values.receiptType === receiptTypeEnum.ApplyDebitMemo
                    ? values.dibetMemoTransactionId
                    : values.receiptType === receiptTypeEnum.ApplyPreReceipt
                      ? values.preReceiptId
                      : null
                }
              />

              <hr className='my-4' />

              <div hidden={values.receiptType === receiptTypeEnum.PreReceipt}>
                <ArScheduleList formik={formik} />
              </div>

              <div className='col-12 text-center mt-2'>
                {/* {!isPosted && !isCancelled && (
                  <button
                    disabled={formik.isSubmitting}
                    type='submit'
                    className='btn btn-lg me-1 btn-theme mb-1 rounded-2'
                  >
                    {formik.isSubmitting ? (
                      <div className='spinner-border spinner-border-sm me-2'></div>
                    ) : (
                      <i className='fas fa-lg fa-fw me-2 fa-credit-card'></i>
                    )}
                    {t('Save')}
                  </button>
                )} */}

                {!isCancelled && (
                  <button
                    type='button'
                    className='btn btn-lg me-1 btn-danger mb-1 rounded-2'
                    onClick={() => setShowCancelModal(true)}
                    disabled={formik.isSubmitting}
                  >
                    <i className='fas fa-lg fa-fw me-2 fa-times-circle'></i>
                    {t('إلغاء السند')}
                  </button>
                )}

                <button
                  type='button'
                  className='btn btn-lg me-1 btn-default mb-1 rounded-2'
                  onClick={() => navigate('/AR/ArReceipts', { replace: true })}
                >
                  <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                </button>
              </div>
            </CardFooter>
          </Form>
        </Loading>
      </Card>

      <NeatixModal show={show} setShow={setShow} size='xl' centered>
        {receiptId && <JournalsByReference referenceId={receiptId} />}
      </NeatixModal>

      <NeatixModal show={showCancelModal} setShow={setShowCancelModal} size='md' centered showHeader={false}>
        <div className='text-center'>
          <i className='fas fa-exclamation-triangle fa-3x text-warning mb-3'></i>
          <h4>{t('تأكيد إلغاء السند')}</h4>
          <p className='mb-4'>{t('هل أنت متأكد من أنك تريد إلغاء هذا السند؟ لا يمكن التراجع عن هذا الإجراء.')}</p>

          <div className='d-flex justify-content-center gap-3'>
            <button type='button' className='btn btn-danger' onClick={handleCancelReceipt}>
              <i className='fas fa-check me-2'></i>
              {t('نعم، إلغاء السند')}
            </button>
            <button type='button' className='btn btn-secondary' onClick={() => setShowCancelModal(false)}>
              <i className='fas fa-times me-2'></i>
              {t('تراجع')}
            </button>
          </div>
        </div>
      </NeatixModal>
    </>
  );
};

// const Update = () => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();
//   const { receiptId } = useParams();
//   const [show, setShow] = useState(false);

//   const { Currency, loading: loading4 } = useLookupCurrency();
//   // const { BranchOrgOptions: BranchsOptions, loading: loading3 } = useGetBranchOrgWithPermission();

//   const {
//     OperatingUnitOptions,
//     loading: loading3
//     // error: error7,
//   } = useGetOperatingUnitWithPermission();

//   const { treeCustomerData, error: error2, loading: loading2 } = useGetCustomersList();

//   const { PaymentMethodList } = useGetPaymentMethod();
//   const { groupedOptions, loading: loading5, error: error5 } = useGetBankAccountsList();
//   const { PaymentTypeList, loading: loading6, error: error6 } = useGetPaymentTypeList();

//   useEffect(() => {
//     if (receiptId) {
//       dispatch(getArReceiptsById(receiptId));
//     }
//   }, []);
//   const { ArReceiptsById: data } = useAppSelector(a => a.ArReceipts);

//   // console.log(data);

//   //#region Formik
//   const formik = useFormik({
//     initialValues: {
//       prePaymentTotal: data.paymentType === receiptTypeEnum.PrePayment ? data.amount || 0 : 0, // ليس في البوست
//       //

//       receiptType: data.paymentType ?? '',
//       depositDate: data.depositDate?.toString()?.split('T')[0] ?? '',
//       bankAccountId: data.bankAccountId ?? '',
//       depositMethodId: data.depositMethodId ?? '',
//       amount: data.amount ?? '',
//       currencyCode: data.currencyCode ?? '',
//       currencyConversionRate: data.currencyConversionRate ?? '',
//       peopleId: data.peopleId ?? '',
//       organizationId: data.organizationId ?? '',
//       scheduleList:
//         // [].map((item: any) => ({
//         data?.transactionReceiptList?.map(item => ({
//           id: item.id,
//           apPaymentScheduleId: item.arReceiptScheduleId,
//           amount: item.amount,
//           transactionNum: item.transectionNum,
//           transactionDate: item.transectionDate?.toString()?.split('T')[0],
//           dueDate: item.dueDate?.toString()?.split('T')[0],
//           transactionAmount: item.transectionAmount,
//           schadualAmount: item.schadualAmount,
//           actualRemainingAmount: item.schadualAmount // هنا يجب جلب المبلغ المتبقي لهذه الدفعة !! مازالت غير مهندلة
//         })) ?? []
//     },

//     enableReinitialize: true,
//     // validationSchema: AddApPaymentsSchema(t),

//     onSubmit: async values => {
//       const isConfirmation = await confirmAction('هل أنت متأكد من أنك تريد تعديل هذا السداد؟');
//       if (!isConfirmation) {
//         formik.setSubmitting(false);
//         return;
//       }

//       dispatch(
//         updateArReceipts({
//           //
//           id: data.id,
//           bankAccountId: values.bankAccountId,
//           depositMethodId: values.depositMethodId,
//           depositDate: values.depositDate,
//           amount: values.receiptType === receiptTypeEnum.PrePayment ? values.prePaymentTotal : values.amount,

//           transactionReceiptList:
//             values.receiptType === receiptTypeEnum.PrePayment
//               ? []
//               : values.scheduleList.map(item => ({
//                   id: item.id,
//                   arReceiptScheduleId: item.apPaymentScheduleId,
//                   amount: item.amount
//                 }))
//         })
//       )
//         .unwrap()
//         .then((res: any) => {
//           // debugger;
//           // console.log(res);

//           if (res?.succeeded === true) {
//             CustomAlert({ action: 'Edit' });
//             formik.resetForm();
//           } else {
//             formik.setSubmitting(false);
//             CustomAlert({ action: 'Error', msg: res?.message });
//           }
//         })
//         .catch((error: any) => {
//           formik.setSubmitting(false);
//           CustomAlert({ action: 'Error' });
//         });
//     }
//   });
//   const { values, handleChange: formikhandleChange, errors, touched, setFieldValue, setFieldTouched } = formik;
//   //#endregion

//   // تحديد إذا كان السند مرحلاً
//   const isPosted = data?.postedFlag === true;

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: 'Home',
//               link: '/AR/HomePage'
//             },
//             {
//               name: 'سندات الدفع',
//               link: '/Finance/Ap/ApPayments'
//             },
//             {
//               name: 'تفاصيــل سند الدفع',
//               link: null
//             }
//           ]}
//           PageName='تفاصيــل سند الدفع'
//         />
//       </div>

//       <Card>
//         <Loading loading={loading5 || loading2 || loading3 || loading4}>
//           {/* {isPosted && ( */}
//           {true && (
//             <div className='alert alert-info d-flex align-items-center justify-content-between m-2'>
//               <div className='d-flex align-items-center'>
//                 <i className='fas fa-info-circle fa-2x me-3'></i>
//                 <div>
//                   <h5 className='mb-1'>{t('تم ترحيـل السند')}</h5>
//                   <p className='mb-0'>{t('لا يمكن تعديل السندات بعد الترحيل في النظام')}</p>
//                 </div>
//               </div>

//               {/* الزر في الطرف الآخر */}
//               <button type='button' className='btn btn-sm btn-info' onClick={() => setShow(true)}>
//                 <i className='fa fa-info-circle fa-fw me-1'></i>
//                 {t('عرض القيد')}
//               </button>
//             </div>
//           )}
//           <CardBody>
//             <Form onSubmit={formik.handleSubmit}>
//               <div className='row'>
//                 {/* ('الفرع') */}
//                 <div className='col-lg-3  '>
//                   <div className='form-group mb-3'>
//                     {/* <label className="form-label">{t('الفرع')}</label> */}
//                     <label className='form-label'>{t('الوحدة التشغيليـة')}</label>

//                     <Select
//                       isDisabled
//                       classNamePrefix='react-select'
//                       isLoading={loading3}
//                       isSearchable={true}
//                       isClearable
//                       options={OperatingUnitOptions}
//                       value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
//                       onChange={(option: any) => setFieldValue('organizationId', option === null ? null : option.value)}
//                       placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                     />
//                     <div className='text-danger small'>{touched.organizationId && errors.organizationId}</div>
//                   </div>
//                 </div>
//                 {/* نوع الدفع */}
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('نوع الدفع')}</label>
//                     <Form.Select
//                       disabled
//                       className='form-select'
//                       name='receiptType'
//                       onChange={formikhandleChange}
//                       value={values.receiptType || ''}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                       {PaymentTypeList?.map((item, idx) => (
//                         <option key={idx} value={item.id}>
//                           {i18n.language === 'en' ? item.name : item.name2}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     <div className='text-danger small'>{touched.receiptType && formik.errors.receiptType}</div>
//                   </div>
//                 </div>
//                 {/* {t('العميـل')} */}
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('العميـل')}</label>
//                     <TreeSelect
//                       disabled
//                       showSearch
//                       className='w-100'
//                       treeLine
//                       placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                       allowClear
//                       treeDefaultExpandAll={false} // لا تقم بتوسيع كل العقد افتراضيًا
//                       // loadData={} // يتم تحميل البيانات عند الطلب
//                       // onSearch={} // تنفيذ البحث عند كتابة المستخدم
//                       value={values.peopleId}
//                       onChange={option => {
//                         formik.setFieldValue('peopleId', option === null ? null : option);
//                       }}
//                       treeData={treeCustomerData}
//                       // treeNodeFilterProp="title"
//                       getPopupContainer={triggerNode => triggerNode.parentNode} // يجعل القائمة تظهر داخل نفس عنصر الـ parent
//                     />
//                   </div>
//                 </div>
//                 {/* طريقة الدفع */}
//                 <div className='col-lg-3 '>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('PaymentMethod')}</label>
//                     <Form.Select
//                       className='form-select'
//                       name='depositMethodId'
//                       onChange={formik.handleChange}
//                       value={formik.values.depositMethodId || ''}
//                       // isInvalid={
//                       //   !!(formik.touched.depositMethodId && formik.errors.depositMethodId)
//                       // }
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                       {PaymentMethodList?.map((item: any, idx: number) => (
//                         <option key={++idx} value={item.id}>
//                           {i18n.language === 'en' ? item.name : item.name2}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     <div className='text-danger small'>{touched.depositMethodId && errors.depositMethodId}</div>
//                   </div>
//                 </div>

//                 {/* التاريخ */}
//                 <div className='col-lg-3  '>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('التاريخ')}</label>
//                     <Form.Control
//                       className='form-control'
//                       type='date'
//                       name='depositDate'
//                       onChange={formikhandleChange}
//                       value={values.depositDate || ''}
//                       // isInvalid={!!(touched.depositDate && errors.depositDate)}
//                     />
//                     <div className='text-danger small'>{touched.depositDate && errors.depositDate}</div>
//                   </div>
//                 </div>

//                 {/* apBankAccountId */}
//                 <div className='col-lg-3 '>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('البنك / الصندوق')}</label>

//                     <Select
//                       classNamePrefix='react-select'
//                       isLoading={loading5}
//                       isSearchable={true}
//                       isClearable
//                       options={groupedOptions}
//                       // value={groupedOptions?.find(
//                       //   (f: any) => f?.value === formik.values.bankAccountId
//                       // )}
//                       value={groupedOptions?.find((item: any) =>
//                         item?.options?.some((option: any) => option.value === formik.values.bankAccountId)
//                       )}
//                       onChange={(option: any) => setFieldValue('bankAccountId', option === null ? null : option?.value)}
//                       placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                     />
//                     <div className='text-danger small'>{touched.bankAccountId && errors.bankAccountId}</div>
//                   </div>
//                 </div>
//                 {/* ('Currency') */}
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'> {t('Currency')} </label>
//                     <Form.Select
//                       disabled
//                       className='form-select'
//                       name='currencyCode'
//                       onChange={formikhandleChange}
//                       value={values.currencyCode || ''}
//                       // isInvalid={!!(touched.currencyCode && errors.currencyCode)}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

//                       {Currency &&
//                         Currency?.map((item: any, idx: number) => (
//                           <option key={++idx} value={item.currencyCode}>
//                             {item.description}
//                           </option>
//                         ))}
//                     </Form.Select>
//                     <div className='text-danger small'>{touched.currencyCode && errors.currencyCode}</div>
//                   </div>
//                 </div>
//                 {/* ('معدل العملة') */}
//                 <div className='col-lg-3 '>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('معدل العملة')}</label>
//                     <Form.Control
//                       disabled
//                       readOnly
//                       className='form-control  text-center'
//                       type='text'
//                       autoComplete='off'
//                       name='currencyConversionRate'
//                       // onChange={formikhandleChange}
//                       // value={values.currencyConversionRate || ''}
//                       value={values.currencyConversionRate}
//                       // isInvalid={!!(touched.currencyConversionRate && errors.currencyConversionRate)}
//                     />
//                     <div className='text-danger small'>
//                       {touched.currencyConversionRate && errors.currencyConversionRate}
//                     </div>
//                   </div>
//                 </div>

//                 {values.receiptType === receiptTypeEnum.PrePayment && (
//                   <div className='col-lg-3'>
//                     <div className='form-group mb-3'>
//                       <label className='form-label'>{t('مبلغ الدفعة المقدمة')}</label>
//                       <Form.Control
//                         className='form-control text-center fs-5 fw-bold text-theme'
//                         type='text'
//                         autoComplete='off'
//                         name='prePaymentTotal'
//                         onChange={formikhandleChange}
//                         value={values.prePaymentTotal || ''}
//                         onInput={e => {
//                           const input = e.target as HTMLInputElement;
//                           input.value = input.value.replace(/[^0-9]/g, '');
//                         }}
//                       />
//                       <div className='text-danger small'>{errors.amount}</div>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               <div className='row' hidden={values.receiptType === receiptTypeEnum.PrePayment}>
//                 <ArScheduleList formik={formik} />
//               </div>

//               <div className='col-12 text-center mt-2'>
//                 <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme mb-1'>
//                   {formik.isSubmitting ? (
//                     <div className='spinner-border spinner-border-sm me-2'></div>
//                   ) : (
//                     <i className='fas fa-lg fa-fw me-2 fa-credit-card'></i>
//                   )}
//                   {t('Save')}
//                 </button>
//                 <button
//                   type='button'
//                   className='btn btn-lg me-1 btn-default mb-1'
//                   onClick={() => navigate('/Ar/ArReceipts', { replace: true })}
//                 >
//                   <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//                 </button>
//               </div>
//             </Form>
//           </CardBody>
//         </Loading>
//       </Card>
//       <NeatixModal show={show} setShow={setShow} size='xl'>
//         {receiptId && <JournalsByReference referenceId={receiptId} />}
//       </NeatixModal>
//     </>
//   );
// };

export default Update;
